import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import HeaderRec from '../../header/headerRec';
import MissionInfo from '../../commun/MissionInfo';
import ProfilRecherche from '../../commun/ProfilRecherche';
import SendCandidats from '../SendCandidats/SendCandidats';
import LoadingPopup from '../../commun/LoadingPopup';
import './TravailMission.css';
import axios from 'axios';
import SharePopup from '../../commun/SharePopup';
import NotFound404 from '../../commun/NotFound404';

const TravailMission = () => {
  const { id } = useParams();
  const location = useLocation();
  const [mission, setMission] = useState(null);
  const [entreprise, setEntreprise] = useState(null);
  const [activeTab, setActiveTab] = useState('mission');
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const recruteurName = localStorage.getItem("recruteurName");
  const authToken = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");
  const params = new URLSearchParams(location.search);
  const preselectedTalentId = params.get('t');
  const [selectedMission, setSelectedMission] = useState(null);
  const [favorites, setFavorites] = useState([]);
  const [notFound, setNotFound] = useState(false);

  const fetchFavorites = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/recruteur`, {
        headers: { Authorization: `Bearer ${authToken}` },
        params: { userId }
      });
      const favIds = response.data.map(m => m._id);
      setFavorites(favIds);
    } catch (err) {
      console.error('Erreur chargement favoris:', err);
    }
  };
  useEffect(() => {
    const fetchMission = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/missions/${id}`);
        if (!res.ok) {
          setNotFound(true);
          return;
        }
        const data = await res.json();
        setMission(data);
        fetchEntreprise(data.createdBy);
      } catch (err) {
        console.error('Erreur chargement mission:', err);
        setNotFound(true);
      }
    };

    const fetchEntreprise = async (userId) => {
      try {
        const res = await fetch(`${API_BASE}/api/entreprise/profil/${userId}`);
        const data = await res.json();
        setEntreprise(data);
      } catch (err) {
        console.error('Erreur chargement entreprise:', err);
        setNotFound(true);
      }
    };

    fetchMission();
    fetchFavorites();
  }, [id, API_BASE]);

  if (!mission || !entreprise) {
    return <LoadingPopup open message="Chargement..." />;
  }
  if (notFound) return <NotFound404 />;

  const toggleFavorite = async (missionId) => {
    try {
      await axios.post(
        `${API_BASE}/api/recruteur/favorites/${missionId}?userId=${userId}`,
        {},
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      setFavorites(prev =>
        prev.includes(missionId)
          ? prev.filter(id => id !== missionId)
          : [...prev, missionId]
      );
    } catch (err) {
      console.error("Erreur lors du changement de favori :", err);
      setNotFound(true);
    }
  };

  return (
    <div className="travail-mission-page">
      <HeaderRec recruteurName={recruteurName} authToken={authToken} userId={userId} />

      <main className="travail-mission-container">
        {/* Partie gauche avec onglets */}
        <section className="mission-info-section">
          <div className="tab-navigation">
            <button
              className={activeTab === 'mission' ? 'active' : ''}
              onClick={() => setActiveTab('mission')}
            >
              MISSION
            </button>
            <button
              className={activeTab === 'profil' ? 'active' : ''}
              onClick={() => setActiveTab('profil')}
            >
              PROFIL RECHERCHÉ
            </button>
          </div>

          <div className="tab-content-travaill">
            {activeTab === 'mission' && (
              <MissionInfo
                mission={mission}
                editable={false}
                isRecruteurView={true}
                favorites={favorites}
                entrepriseLogo={entreprise.logo}
                toggleFavorite={toggleFavorite}
                setSelectedMission={setSelectedMission}
              />
            )}
            {activeTab === 'profil' && (
              <ProfilRecherche
                editedMission={mission}
                editable={false}
                entrepriseLogo={entreprise.logo}
              />
            )}
          </div>
        </section>

        {/* Partie droite avec formulaire de candidats */}
        <section className="send-candidats-section">
          <SendCandidats preselectedTalentId={preselectedTalentId} />
        </section>

        {selectedMission && (
        <SharePopup
          shareUrl={`${process.env.REACT_APP_FRONTEND_BASE_URL}/Recruteur/Details/${selectedMission._id}`}
          onClose={() => setSelectedMission(null)}
        />
      )}
      </main>
    </div>
  );
};

export default TravailMission;
